import ErrorModal from '../ErrorModal';
import IFrameModal from '../IFrameModal';
import { l10n } from '@ott/l10n';
import {
  actions as virtualCardActions,
  selectors as virtualCardSelectors,
} from '@ott/shared-virtual-card-logic';
import { unwrapResult } from '@reduxjs/toolkit';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const defaultIFrameModalSize = {
  width: 387,
  height: 376,
};

type Props = {
  onClose: VoidFunction;
};

const DetailsModal = ({ onClose }: Props) => {
  const [isError, setIsError] = useState(false);
  const { data: { redirectUrl } = {} } = useSelector(virtualCardSelectors.getDetailsLink);

  const dispatch = useDispatch<any>();

  useEffect(() => {
    dispatch(virtualCardActions.getDetailsLink())
      .then(unwrapResult)
      .catch(() => setIsError(true));
  }, [dispatch]);

  if (isError) {
    return (
      <ErrorModal
        isOpen={true}
        title={l10n('virtualCard.errors.detailsError.title')}
        description={l10n('virtualCard.errors.detailsError.description')}
        actionButtonText={l10n('virtualCard.errors.detailsError.action')}
        onClose={onClose}
        onAction={onClose}
      />
    );
  }

  if (!redirectUrl) {
    return null;
  }

  return (
    <IFrameModal
      src={redirectUrl}
      isOpen={true}
      onClose={onClose}
      defaultSize={defaultIFrameModalSize}
    />
  );
};

export default React.memo(DetailsModal);
